import dice from "./dice.png";
import logo from "./logo.png";
import offers from "./offers.png";
import compare from "./compare.png";
import robot from "./robot.png";
import search from "./search.svg";
import "./App.css";
import Button from "./Button";
import Search from "./Search";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div class="logo-container">
          <div class="extruded-logo">
            <img src={logo} className="App-logo" alt="logo" />
            <img src={logo} className="App-logo" alt="logo" />
            <img src={logo} className="App-logo" alt="logo" />
            <img src={logo} className="App-logo" alt="logo" />
            <img src={logo} className="App-logo" alt="logo" />
          </div>
        </div>
        <a href="https://aicasino.today" class="Menu-title">
          AIcasino.today
        </a>
      </header>
      <div className="App-hero">
        <h1 className="Hero-title">The Daily AI Assistant for Casino Offers</h1>
        <div className="Hero-subtitle">
          Discover top online casinos, bonuses, and games — ranked daily and
          recommended by AI. No guesswork. Simply the best deals.
        </div>
      </div>
      <div className="Search-container">
        <Button className="Button-quick" style={{ "--delay": "0.5s" }}>
          Highest Jackpot
        </Button>
        <Button className="Button-quick" style={{ "--delay": "1.0s" }}>
          Best Cashback
        </Button>
        <Button className="Button-quick" style={{ "--delay": "1.5s" }}>
          New Games
        </Button>
        <Search />
      </div>
      <img className="Dice-left" src={dice} alt="dice" />
      <img className="Dice-right" src={dice} alt="dice" />
      <div className="Content-container">
        <h2 className="Content-title">Why AIcasino.today for casino picks?</h2>
        <p className="Content-body">
          Finding the right online casino can feel overwhelming. Our AI scans
          hundreds of platforms, reviews player feedback, and analyzes
          promotions to deliver personalized recommendations that save you time
          and maximize your experience.
        </p>
        <div className="Content-comparison">
          <div className="Comparison-box">
            <h3 className="Comparison-title">AI Powered Rankings</h3>
            <img className="Comparison-image" src={robot} alt="robot" />
            <ul className="Comparison-list">
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Scans hundreds of casino sites
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Evaluates trust, UX, and payouts
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Learns from player behavior
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Delivers personalized picks
              </li>
            </ul>
          </div>
          <div className="Comparison-box">
            <h3 className="Comparison-title">Exclusive Bonus Offers</h3>
            <img className="Comparison-image" src={offers} alt="offers" />
            <ul className="Comparison-list">
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Unlocks deals not found elsewhere
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Matches bonuses to your play style
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Tracks wagering requirements
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Maximizes your starting balance
              </li>
            </ul>
          </div>
          <div className="Comparison-box">
            <h3 className="Comparison-title">Transparent Comparison</h3>
            <img className="Comparison-image" src={compare} alt="compare" />
            <ul className="Comparison-list">
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Side-by-side casino insights
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Real data, no hidden promotions
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Clear pros and cons for each site
              </li>
              <li className="Comparison-item">
                <img src={search} alt="bullet" className="Comparison-icon" />
                Helps you choose with confidence
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="Content-container">
        <h2 className="Content-title">What turns you on?</h2>
        <p className="Content-body">
          Everyone has their own thrill. Whether it's chasing jackpots, hunting
          cashback, or exploring endless games — our AI delivers offers made
          just for your style of play.
        </p>
        <div className="Content-comparison">
          <div className="Feature-box">
            <div className="Feature-image Feature-jackpot">
              <span className="Feature-button">
                <img src={search} alt="bullet" className="Feature-icon" />
                Highest Jackpot
              </span>
            </div>
            <h3 className="Feature-title">The Jackpot</h3>
            <p className="Feature-body">
              I am interested in the highest Jackpot.
            </p>
          </div>
          <div className="Feature-box">
            <div className="Feature-image Feature-treasure">
              <span className="Feature-button">
                <img src={search} alt="bullet" className="Feature-icon" />
                Best Deals
              </span>
            </div>
            <h3 className="Feature-title">Treasure Hunt</h3>
            <p className="Feature-body">
              I want to find the biggest cash back.
            </p>
          </div>
          <div className="Feature-box">
            <div className="Feature-image Feature-games">
              <span className="Feature-button">
                <img src={search} alt="bullet" className="Feature-icon" />
                Most Games
              </span>
            </div>
            <h3 className="Feature-title">Millions of Games</h3>
            <p className="Feature-body">
              I want to play the widest range of games.
            </p>
          </div>
        </div>
      </div>
      <footer className="Footer-body">
        AB UND ZU Web Design L.L.C. &copy; 2025
      </footer>
    </div>
  );
}

export default App;
